import { TextField } from '@material-ui/core'
import React, { ReactElement } from 'react'

export default function TextFieldsEmptyExample(): ReactElement {
  return (
    <div style={{ marginTop: 10 }}>
      <TextField
        type='mainDiagnosis'
        label='Заболевание'
        style={{ width: '70%' }}
        // fullWidth
        placeholder='Заболевание'
        value=''
        variant='outlined'
      />
      <TextField
        type='mainDiagnosis'
        label='Код МКБ'
        style={{ maxWidth: '28%', marginLeft: '2%' }}
        // fullWidth
        placeholder='Код МКБ'
        value=''
        variant='outlined'
      />
    </div>
  )
}
